import script from "./MessagesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesPage.vue?vue&type=script&setup=true&lang=js"

import "./MessagesPage.vue?vue&type=style&index=0&id=076c8350&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076c8350"]])

export default __exports__